import { Button, Input, Label, Modal } from "@mixitone/components";
import { ApplicationView } from "@mixitone/mvc";
import { FundingOutreachFormController } from "components/Pages/Funding/FundingOutreachFormController";

/** Modal to enter the actual amount the funder agreed to award; sets status to Approved. */
const FundingOutreachAcceptAmountModal = () => {
  const controller = FundingOutreachFormController.use();
  const { showAcceptAmountModal, acceptAmountPounds } = controller.state;

  if (!showAcceptAmountModal) return null;

  return (
    <Modal title="Actual amount agreed" onClose={() => controller.actionCloseAcceptAmountModal()} portal>
      <div className="flex flex-col gap-4">
        <p className="text-sm text-gray-600">
          Enter the amount the funder has agreed to award. This will set the outreach status to Approved.
        </p>
        <div>
          <Label htmlFor="accept-amount-pounds">Amount</Label>
          <Input
            id="accept-amount-pounds"
            type="number"
            min={0}
            step={0.01}
            value={acceptAmountPounds}
            onChange={(e) => controller.actionSetAcceptAmountPounds(e.target.value)}
            className="mt-1 w-full"
          />
        </div>
        <div className="flex justify-end gap-2">
          <Button kind="secondary" onClick={() => controller.actionCloseAcceptAmountModal()}>
            Cancel
          </Button>
          <Button
            kind="primary"
            onClick={() => {
              const n = Number.parseFloat(acceptAmountPounds.trim());
              if (!Number.isFinite(n) || n < 0) return;
              controller.actionSetStatusApproved(Math.round(n * 100));
              controller.actionCloseAcceptAmountModal();
            }}
            disabled={!acceptAmountPounds.trim() || !Number.isFinite(Number(acceptAmountPounds))}
          >
            Confirm
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default ApplicationView(FundingOutreachAcceptAmountModal);
